import axios from "axios";
import { BASE_URL } from "../constants";

export const logoutSession = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }

  try {
    await axios.post(
      `${BASE_URL}/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    // Silent failure: client should still clear local auth state.
    console.error("Failed to logout session on server:", error);
  }
};
